export default function lazyBackgroundHandler() {
    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.lazy-background'));

    if (
        'IntersectionObserver' in window && 'IntersectionObserverEntry' in window
        && 'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
        const lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.remove('lazy-background');
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach((lazyBackground) => {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    } else {
        // legacy browsers (probably can be removed)
        lazyBackgrounds.forEach((background) => {
            background.target.classList.remove('lazy-background');
        });
    }
};
